import { createContext } from 'react'

import { ProductIds } from 'core/application/commons/config'

import useLoginUser from 'common/hooks/useLoginUser'

import QsehraLogo from '../../assets/images/QSEHRA.svg'
import PerksLogo from '../../assets/images/Stipends.svg'
import GroupHRALogoMobile from '../../assets/images/group-hra-ver-2-mobile.svg'
import GroupHRALogo from '../../assets/images/group-hra-ver-2.svg'
import IchraLogo from '../../assets/images/ichra-logo.svg'

export const ProductConfig = new Map([
  [
    ProductIds.GroupHraId,
    {
      productId: ProductIds.GroupHraId,
      productName: 'GCHRA',
      productLogo: GroupHRALogo,
      productLogoMobile: GroupHRALogoMobile,
      signUpTitle: 'admin-signup.signup.gchra.header-title',
    },
  ],
  [
    ProductIds.Perks,
    {
      productId: ProductIds.Perks,
      productName: 'WorkPerks',
      productLogo: PerksLogo,
      signUpTitle: 'admin-signup.signup.perks.header-title',
    },
  ],
  [
    ProductIds.QsehraId,
    {
      productId: ProductIds.QsehraId,
      productName: 'QSEHRA',
      productLogo: QsehraLogo,
      signUpTitle: 'admin-signup.signup.qsehra.header-title',
    },
  ],
  [
    ProductIds.IchraId,
    {
      productId: ProductIds.IchraId,
      productName: 'ICHRA',
      productLogo: IchraLogo,
      signUpTitle: 'admin-signup.signup.ichra.header-title',
    },
  ],
])

export const ProductContext = createContext(ProductConfig.get(ProductIds.GroupHraId))

const ProductProvider = (props) => {
  const [user] = useLoginUser()

  const currentProduct = user ? ProductConfig.get(user.productId) : ProductConfig.get(ProductIds.GroupHraId)

  return <ProductContext.Provider value={currentProduct} {...props} />
}

export default ProductProvider
